module.exports = __webpack_public_path__ + "static/media/hortifrut.944fc0b7.png";